import {useState, useEffect, useRef} from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {Form} from 'react-bootstrap';
// import * as AuthService from '../../../services/auth';
import {useReactToPrint} from 'react-to-print';
export default function ModalRealLoReport(props) {
  useEffect(() => {
    console.log('CHANGE');
    if (props.item) {
    }
  }, [props.item]);

  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      '@media print { body { -webkit-print-color-adjust: exact; } @page { size: A4; margin-top: 10mm !important }}'
  });

  const [key, setKey] = useState('report');
  return (
    <div className="row">
      <div className="col-12 col-md-11">
        <div className="col-12 d-flex justify-content-end">
          <a>
            <i
              className="fas fa-print"
              onClick={handlePrint}
              style={{cursor: 'pointer'}}
            />
          </a>
        </div>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="report" title="รายงาน">
            <div className="row" style={{padding: 0}} ref={componentRef}>
              <div className="row col-12">
                <div className="col-12" style={{textAlign: 'center'}}>
                  <img src="https://api-passport.advanceagro.net/img/reallo.jpg"></img>
                </div>
                {/* <div className="col-6">
                  <div className="row">
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NPS
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;FG
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;E85
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NPP2
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NPP5A
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NS304
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NPP3
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;NPP5
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;SNST
                      </label>
                    </div>
                    <div className="col-4">
                      <label>
                        <input type="checkbox" />
                        &nbsp;IRC
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="col-12">
                <hr />
              </div>
              {/* <div
                className="col-12 text-center font-weight-bold mb-3"
                style={{textDecoration: 'underline'}}
              >
                <h5>Attendance record</h5>
              </div> */}
              {/* <div className="col-12">
                <hr />
              </div> */}
              <Form.Group className="mb-1 col-12">
                <Form.Label className="text-center" style={{width: '100%'}}>
                  หลักสูตร
                </Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_NAME : ''}
                  disabled
                />
              </Form.Group>
              {/* <Form.Group className="mb-1 col-6">
                <Form.Label>Training Group</Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_GROUP_NAME : ''}
                  disabled
                />
              </Form.Group> */}
              <Form.Group className="mb-1 col-12">
                <Form.Label className="text-center" style={{width: '100%'}}>
                  วิทยากร
                </Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_INSTRUCTOR : ''}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-1 col-6">
                <Form.Label className="text-center" style={{width: '100%'}}>
                  วันที่-เวลา
                </Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_DATE_TRAINING : ''}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-1 col-6">
                <Form.Label className="text-center" style={{width: '100%'}}>
                  สถานที่อบรม
                </Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_VENUE : ''}
                  disabled
                />
              </Form.Group>
              {/* <Form.Group className="mb-1 col-6">
                <Form.Label>Hour(s)</Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.TRAINING_HOUR : '0'}
                  disabled
                />
              </Form.Group> */}
              <div className="mt-2 col-12">
                <table className="table table-bordered">
                  <thead>
                    <tr className="table-primary">
                      <th scope="col" rowSpan={2}>
                        ลำดับ
                      </th>
                      <th scope="col" rowSpan={2}>
                        รหัสพนักงาน
                      </th>
                      <th scope="col" rowSpan={2}>
                        ชื่อ-นามสกุล
                      </th>
                      <th scope="col" rowSpan={2}>
                        ตำแหน่ง
                      </th>
                      <th scope="col" rowSpan={2}>
                        บริษัท
                      </th>
                      <th scope="col" rowSpan={2}>
                        อีเมล
                      </th>
                      <th scope="col" rowSpan={2}>
                        เบอร์โทร
                      </th>
                      <th
                        scope="col"
                        rowSpan={1}
                        colSpan={2}
                        style={{textAlign: 'center'}}
                      >
                        ลายเซ็น
                      </th>
                    </tr>
                    <tr className="table-primary" style={{textAlign: 'center'}}>
                      <th scope="col">เช้า</th>
                      <th scope="col">บ่าย</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.report && props.report.length > 0 ? (
                      props.report.map((e, i) => (
                        <tr>
                          <th scope="row">{i + 1}</th>
                          <td>
                            {`${e.target_value} ${e.ID_Emp ? '' : '[ลาออก]'}`}
                          </td>
                          <td>{e.EmpName}</td>
                          <td>
                            <textarea
                              id="w3review"
                              name="w3review"
                              rows="2"
                              cols="23"
                            >
                              {e.Position}
                            </textarea>
                          </td>
                          <td>{e.Company_Code}</td>
                          <td>
                            <textarea
                              id="w3review"
                              name="w3review"
                              rows="2"
                              cols="23"
                            >
                              {e.Email}
                            </textarea>
                          </td>
                          <td>{e.Sim_Number}</td>
                          <td>
                            <img
                              style={{
                                height: 35,
                                maxWidth: 120,
                                width: '100%',
                                objectFit: 'contain'
                              }}
                              src={e.signature}
                              alt="เช้า"
                            />
                          </td>
                          <td>
                            <img
                              style={{
                                height: 35,
                                maxWidth: 120,
                                width: '100%',
                                objectFit: 'contain'
                              }}
                              src={e.signature2}
                              alt="บ่าย"
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <th scope="row" colSpan={9}>
                          No Data
                        </th>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th
                        scope="row"
                        colSpan={9}
                        style={{textAlign: 'right'}}
                        className="text-end"
                      >
                        <div className="row col-12">
                          <div className="col-12" style={{textAlign: 'right'}}>
                            QF-HR-07-1
                            <br />
                            Edition No.1 Date :01-10-2017
                          </div>
                          {/* <div className="col-4" style={{textAlign: 'center'}}>
                            Effective date : 30 Jul 2020
                          </div>
                          <div className="col-4" style={{textAlign: 'right'}}>
                            1(1)
                          </div> */}
                        </div>
                        {/* <br /> */}
                        {/* Date : 15/10.2014
                        <br /> */}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              {/* <div
                className="mt-1 col-12 text-end"
                style={{textAlign: 'right'}}
              >
                RC-HR-001/F5 Edition No.7
                <br />
                Date : 15/10.2014
                <br />
              </div> */}
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
